import { render } from "./menuItemDesktop.vue?vue&type=template&id=3266be32&scoped=true"
import script from "./menuItemDesktop.vue?vue&type=script&lang=js"
export * from "./menuItemDesktop.vue?vue&type=script&lang=js"

import "./menuItemDesktop.vue?vue&type=style&index=0&id=3266be32&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3266be32"]])

export default __exports__